import * as Yup from 'yup';

export const CandidateEducationDetailsValidationSchema = Yup.object().shape({
  //Doctorate related validations
  doctorates: Yup.array().when('haveDoctorate', {
    is: 'YES',
    then: Yup.array().of(
      Yup.object().shape({
        doctorateUniversityOrCollegeName: Yup.string().required('University/ College Name value  is required.'),
        doctorateCourseType: Yup.string().required('Course Type value  is required.'),
        doctorateSpecialization: Yup.string().required('Specialization value  is required.'),
        doctorateUniversityOrCollegeEndDate: Yup.string().optional().nullable(),
        doctorateUniversityOrCollegeStartDate: Yup.string().optional().nullable(),
      })
    ),
  }),
  //Graduation related validations
  graduationLst: Yup.array().when('haveGraduation', {
    is: 'YES',
    then: Yup.array().of(
      Yup.object().shape({
        graduationUniversityOrCollegeName: Yup.string().required('University/ College Name value  is required.'),
        graduationCourseType: Yup.string().required('Course Type value  is required.'),
        graduationSpecialization: Yup.string().required('Specialization value  is required.'),
        graduationCGPA: Yup.number('CGPA should be a number')
          .positive('CGPA should be a positive number')
          .typeError('CGPA should be a valid number')
          .nullable(),
        graduationRank: Yup.number('Rank should be a number')
          .positive('Rank should be a positive number')
          .test('is-whole', 'This must be a whole number', (value) => value == null || Number.isInteger(value))
          .nullable(),
        graduationUniversityOrCollegeEndDate: Yup.string().optional().nullable(),
        graduationUniversityOrCollegeStartDate: Yup.string().optional().nullable(),
        graduationDegree: Yup.string().required('Degree is required.'),
        graduationBacklogStartDate: Yup.string()
          .when('haveGraduationBackLog', {
            is: (havGraduationBackLog) => havGraduationBackLog,
            then: Yup.string().nullable(),
          })
          .nullable(),
        graduationBacklogEndDate: Yup.string()
          .when('haveGraduationBackLog', {
            is: (havGraduationBackLog) => havGraduationBackLog,
            then: Yup.string().nullable(),
          })
          .nullable(),
        graduationBacklogReason: Yup.string()
          .when('haveGraduationBackLog', {
            is: (havGraduationBackLog) => havGraduationBackLog,
            then: Yup.string().nullable(),
          })
          .nullable(),
      })
    ),
  }),
  //PG Related Validations
  pgLst: Yup.array().when('havePG', {
    is: 'YES',
    then: Yup.array().of(
      Yup.object().shape({
        pgUniversityOrCollegeName: Yup.string().required('University/ College Name value  is required.'),
        pgCourseType: Yup.string().required('Course Type value  is required.'),
        pgSpecialization: Yup.string().required('Specialization value  is required.'),
        pgCGPA: Yup.number('CGPA should be a number')
          .positive('CGPA should be a positive number')
          .typeError('CGPA should be a valid number')
          .nullable(),
        pgRank: Yup.number('Rank should be a number')
          .positive('Rank should be a positive number')
          .test('is-whole', 'This must be a whole number', (value) => value == null || Number.isInteger(value))
          .nullable(),
        pgUniversityOrCollegeEndDate: Yup.string().optional().nullable(),
        pgUniversityOrCollegeStartDate: Yup.string().optional().nullable(),
        pgDegree: Yup.string().required('Degree is required.'),
        pgBacklogStartDate: Yup.string()
          .when('havePgBackLog', {
            is: (havePgBackLog) => havePgBackLog,
            then: Yup.string().nullable(),
          })
          .nullable(),
        pgBacklogEndDate: Yup.string()
          .when('havePgBackLog', {
            is: (havePgBackLog) => havePgBackLog,
            then: Yup.string().nullable(),
          })
          .nullable(),
        pgBacklogReason: Yup.string()
          .when('havePgBackLog', {
            is: (havePgBackLog) => havePgBackLog,
            then: Yup.string().nullable(),
          })
          .nullable(),
      })
    ),
  }),
  hseSchoolName: Yup.string().nullable(),
  hseStartDate: Yup.string().nullable(),
  hseEndDate: Yup.string().nullable(),
  hseCGPA: Yup.number('CGPA should be a number')
    .positive('CGPA should be a positive number')
    .nullable()
    .typeError('CGPA should be a valid number'),
  hseRank: Yup.number('Rank should be a number')
    .positive('Rank should be a positive number')
    .test('is-whole', 'This must be a whole number', (value) => value == null || Number.isInteger(value))
    .nullable(),
  highSchoolSchoolName: Yup.string().nullable(),
  highSchoolStartDate: Yup.string().nullable(),
  highSchoolEndDate: Yup.string().nullable(),
  highSchoolCGPA: Yup.number('CGPA should be a number')
    .positive('CGPA should be a positive number')
    .nullable()
    .typeError('CGPA should be a valid number'),
  highSchoolRank: Yup.number('Rank should be a number')
    .positive('Rank should be a positive number')
    .test('is-whole', 'This must be a whole number', (value) => value == null || Number.isInteger(value))
    .nullable(),
  hseBacklogStartDate: Yup.string()
    .when('hasHseBackLog', {
      is: true,
      then: Yup.string().nullable(),
    })
    .nullable(),
  hseBacklogEndDate: Yup.string()
    .when('hasHseBackLog', {
      is: true,
      then: Yup.string().nullable(),
    })
    .nullable(),
  hseBacklogReason: Yup.string()
    .when('hasHseBackLog', {
      is: true,
      then: Yup.string().nullable(),
    })
    .nullable(),
  highSchoolBacklogStartDate: Yup.string()
    .when('hashighSchoolBackLog', {
      is: true,
      then: Yup.string().nullable(),
    })
    .nullable(),
  highSchoolBacklogEndDate: Yup.string()
    .when('hashighSchoolBackLog', {
      is: true,
      then: Yup.string().nullable(),
    })
    .nullable(),
  highSchoolBacklogReason: Yup.string()
    .when('hashighSchoolBackLog', {
      is: true,
      then: Yup.string().nullable(),
    })
    .nullable(),
  pgBacklogReason: Yup.string()
    .when('havePgBackLog', {
      is: true,
      then: Yup.string().nullable(),
    })
    .nullable(),
  otherCertificates: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string().nullable(),
      })
    )
    .nullable(),
});